/*
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-18 11:10:53
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-10-21 20:43:05
 * @FilePath: \git\xht-web-business\src\api\coupon.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 优惠券相关API接口
 */
import request from '@/utils/request'

/**
 * 获取优惠券列表
 * @param {Object} params - 查询参数
 * @param {string} params.parkingName - 停车场名称
 * @param {string} params.couponName - 优惠券名称
 * @param {string} params.merchantName - 商户名称
 * @param {string} params.couponType - 优惠券类型
 * @param {number} params.pageNo - 页码，默认1
 * @param {number} params.pageSize - 每页大小，默认40
 * @returns {Promise} 返回优惠券列表数据
 */
export function getCouponList(params = {}) {
  return request({
    url: '/market/coupon/list',
    method: 'post',
    data: params
  })
}

/**
 * 获取优惠券详情
 * @param {number} id - 优惠券ID
 * @returns {Promise} 返回优惠券详情
 */
export function getCouponDetail(id) {
  return request({
    url: `/market/coupon/${id}`,
    method: 'get'
  })
}

/**
 * 创建优惠券（复用后端营销创建接口）
 * 后端路径：POST /market/coupon/add
 * @param {Object} data - 提交数据
 */
export function createCoupon(data = {}) {
  return request({
    url: '/market/coupon/add',
    method: 'post',
    data
  })
}

// 新增：更新二维码配置（不影响原创建接口）
export function updateCouponQrConfig(templateId, data = {}) {
  return request({
    url: '/market/coupon/qr-config',
    method: 'post',
    params: { templateId },
    data
  })
}

/**
 * 记录优惠券发放
 * @param {Object} data - 发放记录
 */
export function addCouponIssuanceRecord(data = {}) {
  return request({
    url: '/market/api/marketing/coupon-issuance-record/add',
    method: 'post',
    data
  })
}

/**
 * 获取优惠券列表（分页）
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回分页优惠券列表数据
 */
export function getCouponListWithPage(params = {}) {
  return request({
    url: '/market/coupon/page',
    method: 'post',
    data: params
  })
}

/**
 * 获取优惠券总数
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回优惠券总数
 */
export function getCouponCount(params = {}) {
  return request({
    url: '/market/coupon/count',
    method: 'post',
    data: params
  })
}

/**
 * 更新优惠券
 * @param {Object} data - 更新数据
 * @returns {Promise} 返回更新结果
 */
export function updateCoupon(data = {}) {
  return request({
    url: '/market/coupon/update',
    method: 'post',
    data
  })
}

/**
 * 删除优惠券
 * @param {string} couponId - 优惠券ID
 * @returns {Promise} 返回删除结果
 */
export function deleteCoupon(couponId) {
  return request({
    url: `/market/coupon/delete/${couponId}`,
    method: 'post'
  })
}

/**
 * 批量获取优惠券
 * @param {Array} couponIds - 优惠券ID数组
 * @returns {Promise} 返回优惠券列表
 */
export function getCouponsByIds(couponIds) {
  return request({
    url: '/market/coupon/batch',
    method: 'post',
    data: couponIds
  })
}

/**
 * 发放优惠券
 * @param {Object} data - 发放数据
 * @returns {Promise} 返回发放结果
 */
export function issueCoupon(data = {}) {
  return request({
    url: '/market/coupon/order/add',
    method: 'post',
    data
  })
}

/**
 * 发放优惠券（dispatch接口，参照管理端逻辑）
 * @param {string} plateNumber - 车牌号
 * @param {string} businessId - 商户ID（UUID格式）
 * @param {string} couponId - 优惠券ID（UUID格式）
 * @returns {Promise} 返回发放结果
 */
export function dispatchCoupon(plateNumber, businessId, couponId) {
  return request({
    url: '/market/coupon/order/dispatch',
    method: 'post',
    params: {
      plateNumber,
      businessId,
      couponId
    }
  })
}

/**
 * 获取优惠券类型枚举
 * @returns {Object} 优惠券类型映射
 */
export function getCouponTypes() {
  return {
    'CASH': '代金券',
    'TIME': '时长券', 
    'PERCENT': '折扣券',
    'FREE': '全免券'
  }
}

/**
 * 获取优惠券发放记录（分页）
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回分页优惠券发放记录数据
 */
export function getCouponIssuanceRecordPage(params = {}) {
  return request({
    url: '/market/api/marketing/coupon-issuance-record/page',
    method: 'post',
    data: params
  })
}

/**
 * 旋转优惠券二维码版本（更新后旧码失效）
 * @param {string} businessId
 * @param {string} couponId
 */
export function rotateCouponQr(businessId, couponId) {
  return request({
    url: '/market/coupon/qr/rotate',
    method: 'post',
    data: { businessId, couponId }
  })
}

/**
 * 获取优惠券二维码当前版本号
 * @param {string} businessId - 商户ID
 * @param {string} couponId - 优惠券ID
 * @returns {Promise} 返回当前版本号
 */
export function getCurrentQrVersion(businessId, couponId) {
  return request({
    url: '/market/coupon/qr/current-version',
    method: 'post',
    data: { businessId, couponId }
  })
}

/**
 * 校验优惠券二维码是否有效（版本与有效期由前后端共同约束）
 * @param {string} businessId
 * @param {string} couponId
 * @param {string} version
 */
export function validateCouponQr(businessId, couponId, version) {
  return request({
    url: '/market/coupon/qr/validate',
    method: 'post',
    data: { businessId, couponId, version }
  })
}

/**
 * 获取或刷新优惠券动态二维码Code
 * @param {string} businessId - 商户ID
 * @param {string} couponId - 优惠券ID
 * @param {string} code - 可选的code参数，如果传入且有效则返回该code，否则生成新的
 * @param {boolean} forceRefresh - 是否强制刷新，如果为true，则使旧的code失效，生成新的code
 * @returns {Promise} 返回有效的code
 */
export function refreshCouponCode(businessId, couponId, code, forceRefresh) {
  return request({
    url: '/market/coupon/code/refresh',
    method: 'get',
    params: {
      businessId,
      couponId,
      ...(code ? { code } : {}),
      ...(forceRefresh !== undefined ? { forceRefresh } : {})
    }
  })
}

/**
 * 使code失效并生成新的code
 * @param {string} businessId - 商户ID
 * @param {string} couponId - 优惠券ID
 * @param {string} code - 要失效的code
 * @returns {Promise<boolean>} 如果code和redis中的code一致，返回true；如果code和redis中的code不一致，返回false
 */
export function invalidateCouponCode(businessId, couponId, code) {
  return request({
    url: '/market/coupon/code/invalid',
    method: 'post',
    params: {
      businessId,
      couponId,
      code
    }
  })
}

/**
 * 获取优惠券二维码信息（商家信息和优惠券信息）
 * @param {string} businessId - 商户ID
 * @param {string} couponId - 优惠券ID
 * @returns {Promise} 返回商家和优惠券信息
 */
export function getCouponQrInfo(businessId, couponId) {
  return request({
    url: '/market/coupon/qr/info',
    method: 'get',
    params: {
      businessId,
      couponId
    }
  })
}

/**
 * 领取优惠券（扫码领取）
 * @param {string} businessId - 商户ID
 * @param {string} couponId - 优惠券ID
 * @param {string} plateNumber - 车牌号
 * @returns {Promise} 返回优惠券订单信息
 */
export function redeemCoupon(businessId, couponId, plateNumber) {
  return request({
    url: '/market/coupon/qr/redeem',
    method: 'post',
    params: {
      businessId,
      couponId,
      plateNumber
    }
  })
}